import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import SideBarSubMenu from "./SideBarSubMenu";
import { useContext } from "react";
import { AuthContext } from "../../../Contexts/AuthContext/AuthProvider";
import SideBarMenu from "./SideBarMenu";
import Skeleton from "react-loading-skeleton";
import logo from "./../../../logo.jpg";
const SideBar = ({ menuSHow, setMenuShow }) => {
  const { authUser, token } = useContext(AuthContext);

  const [notificationData, setNotificationData] = useState([]);
  const [liveChatData, setLiveChatData] = useState(0);

  useEffect(() => {
    try {
      const interval = setInterval(() => {
        fetchData();
      }, 2000);
      return () => clearInterval(interval);
    } catch (error) {

    }
  }, [notificationData]);

  const fetchData = async () => {
    try {
      fetch(`https://api.wlffinance.org/api/admin/notification/user`, {
        method: "GET",
      })
        .then((res) => res.json())
        .then((data) => {
          if (data) {
            setNotificationData(data);
          }

        })
        .catch((error) => {
          // console.log(error);
        });

      fetch(`https://chat-api.wlffinance.org/api/admin/notification/view/${authUser?._id}`, {
        method: "GET",
      })
        .then((res) => res.json())
        .then((data) => {
          if (data) {
            setLiveChatData(data?.PendingLiveChats);
          }

        })
        .catch((error) => {
          // console.log(error);
        });

    } catch (error) {

    }
  };



  const routes = [
    {
      auth: authUser?.dashboard,
      path: "/admin/dashboard",
      name: "Dashboard",
      icon: "menu-icon las la-home",
    },
    {
      auth: authUser?.crypto_currency,
      path: "",
      name: "Trade List",
      icon: "menu-icon las la-coins",
      subRoutes: [
        {
          path: "/admin/crypto/currency/list",
          name: "Crypto Currency",
        },
        {
          path: "/admin/forex/list",
          name: "Forex",
        },
        {
          path: "/admin/stock/list",
          name: "Stocks",
        },
        // {
        //   path: "/admin/indices/list",
        //   name: "Indices (CFDs)",
        // },
        // {
        //   path: "/admin/energises/list",
        //   name: "Energises (CFDs)",
        // },

        {
          path: "/admin/metals/list",
          name: "Metals",
        },
        {
          path: "/admin/popular/market/list",
          name: "Hot",
        },
      ],
    },
    {
      auth: authUser?.trade_setting,
      path: "/admin/trade/setting",
      name: "Trade Setting",
      icon: "menu-icon las la-cog",
    },
    {
      auth: authUser?.new_coin,
      path: "",
      name: "New Coin",
      icon: "menu-icon las la-coins",
      subRoutes: [
        {
          path: "/admin/new/coin/lists",
          name: "New Coin Lists",
        },
        {
          path: "/admin/new/coin/user/buy/history/lists",
          name: "User Buy New Coin",
        },
        {
          path: "/admin/new/coin/user/sell/history/lists",
          name: "User Sell New Coin",
        },
        {
          path: "/admin/new/coin/user/history/lists",
          name: "User All New Coin",
        },
      ],
    },
    {
      auth: authUser?.new_coin,
      path: "",
      name: "NFT",
      icon: "menu-icon las la-coins",
      subRoutes: [
        {
          path: "/admin/nft/lists",
          name: "NFT Lists",
        },
        {
          path: "/admin/nft/user/buy/history/lists",
          name: "User Buy NFT",
        },
        {
          path: "/admin/nft/user/sell/history/lists",
          name: "User Sell NFT",
        },
        {
          path: "/admin/nft/user/history/lists",
          name: "User All NFT",
        },
      ],
    },
    {
      auth: authUser?.manage_staff,
      path: "/admin/staff",
      name: "Manage Staff",
      icon: "menu-icon la-user-astronaut",
    },
    {
      auth: authUser?.trade_log,
      path: "",
      name: "Binary Trade log",
      icon: "menu-icon las la-dice",
      subRoutes: [
        {
          path: "/admin/trade/log",
          name: "All",
        },
        {
          path: "/admin/trade/log/wining",
          name: "Wining",
        },
        {
          path: "/admin/trade/log/losing",
          name: "Losing",
        },
        {
          path: "/admin/trade/log/draw",
          name: "Draw",
        },
      ],
    },
    {
      auth: authUser?.trade_log,
      path: "",
      name: "Live Trade log",
      icon: "menu-icon las la-dice",
      subRoutes: [
        {
          path: "/admin/live/trade/log",
          name: "Running Trade",
        },
        {
          path: "/admin/live/trade/log/pending",
          name: "Pending Trade",
        },
        {
          path: "/admin/live/trade/log/close",
          name: "Close Trade",
        },
      ],
    },

    {
      auth: authUser?.manage_users,
      path: "/settings",
      name: "Manage Users",
      icon: "menu-icon las la-users",
      notification: notificationData?.TotalUser,
      subRoutes: [
        {
          path: "/admin/users/active",
          name: "Active Users",
          notification: notificationData?.ActiveUser,
        },
        {
          path: "/admin/users/banned",
          name: "Banned Users",
          notification: notificationData?.BannedUser,
        },
        {
          path: "/admin/users/email-unverified",
          name: "Email Unverified",
        },
        {
          path: "/admin/users/mobile-unverified",
          name: "Mobile Unverified",
        },
        {
          path: "/admin/users/kyc-unverified",
          name: "KYC Unverified",
        },
        {
          path: "/admin/users/kyc-pending",
          name: "KYC Pending",
          notification: notificationData?.KYCPendingUser,
        },
        {
          path: "/admin/users/with-balance",
          name: "With Balance",
        },
        {
          path: "/admin/users/all",
          name: "All Users",
        },
      ],
    },

    {
      auth: authUser?.user,
      path: "",
      name: "User",
      icon: "menu-icon las la-users",
      subRoutes: [
        {
          path: "/admin/user/view",
          name: "User",
        },
        // {
        //     path: "/admin/user/deposit/pending/view",
        //     name: "Pending Deposit",
        // },

        // {
        //     path: "/admin/user/withdrawal/pending/view",
        //     name: "Pending Withdrawal",
        // },
      ],
    },
    {
      auth: authUser?.payment_gateways,
      path: "",
      name: "Payment Gateways",
      icon: "menu-icon las la-credit-card",
      subRoutes: [
        {
          path: "/admin/gateway/manual",
          name: "Manual Gateways",
        },
      ],
    },
    {
      auth: authUser?.deposits,
      path: "",
      name: "Deposits",
      icon: "menu-icon las la-file-invoice-dollar",
      notification: notificationData?.TotalDeposit,
      subRoutes: [
        {
          path: "/admin/deposit/pending",
          name: "Pending Deposits",
          notification: notificationData?.PendingDeposit,
        },
        {
          path: "/admin/deposit/approved",
          name: "Approved Deposits",
          notification: notificationData?.ApprovedDeposit,
        },
        {
          path: "/admin/deposit/successful",
          name: "Successful Deposits",
          notification: notificationData?.ApprovedDeposit,
        },
        {
          path: "/admin/deposit/rejected",
          name: "Rejected Deposits",
          notification: notificationData?.RejectedDeposit,
        },
        {
          path: "/admin/deposit",
          name: "All Deposits",
        },
      ],
    },
    {
      auth: authUser?.withdrawals,
      name: "Withdrawals",
      icon: "menu-icon la la-bank",
      notification: notificationData?.TotalWithdrawal,
      subRoutes: [
        {
          path: "/admin/withdraw/method",
          name: "Withdrawal Methods",
        },
        {
          path: "/admin/withdraw/pending",
          name: "Pending Withdrawal",
          notification: notificationData?.PendingWithdrawal,
        },
        {
          path: "/admin/withdraw/approved",
          name: "Approved Withdrawal",
          notification: notificationData?.ApprovedWithdrawal,
        },
        {
          path: "/admin/withdraw/rejected",
          name: "Rejected Withdrawal",
          notification: notificationData?.RejectedWithdrawal,
        },
        {
          path: "/admin/withdraw/log",
          name: "All Withdrawal",
        },
      ],
    },
    {
      auth: authUser?.investment_plan,
      name: "Investment Plan",
      icon: "menu-icon la la-bank",
      subRoutes: [
        {
          path: "/admin/investment/plan/lists",
          name: "Promotion",
        },
        {
          path: "/admin/user/running/investment/plan/view",
          name: "Running Investment Plan",
        },
        {
          path: "/admin/user/complete/investment/plan/view",
          name: "Complete Investment Plan",
        },
        {
          path: "/admin/user/all/investment/plan/view",
          name: "All Investment Plan",
        },
      ],
    },
    {
      auth: authUser?.mining,
      name: "Mining",
      icon: "menu-icon la la-bank",
      subRoutes: [
        {
          path: "/admin/running/mining/view",
          name: "Promotion",
        },
        {
          path: "/admin/user/running/mining/view",
          name: "Running Mining",
        },
        {
          path: "/admin/user/complete/mining/view",
          name: "Complete Mining",
        },
        {
          path: "/admin/user/all/mining/view",
          name: "All Mining",
        },
      ],
    },
    {
      auth: authUser?.loan,
      name: "Loan",
      icon: "menu-icon la la-bank",
      notification: notificationData?.TotalLoan,
      subRoutes: [
        {
          path: "/admin/loan/package/view",
          name: "Loan Package",
        },
        {
          path: "/admin/user/pending/loan",
          name: "Pending Loan",
          notification: notificationData?.PendingLoan,
        },
        {
          path: "/admin/user/approved/loan",
          name: "Approved Loan",
          notification: notificationData?.ApprovedLoan,
        },
        {
          path: "/admin/user/reject/loan",
          name: "Reject Loan",
          notification: notificationData?.RejectedLoan,
        },
        {
          path: "/admin/user/completed/loan",
          name: "Completed Loan",
          notification: notificationData?.CompletedLoan,
        },
      ],
    },

    {
      auth: authUser?.live_chat,
      chat: true,
      path: `https://admin-live-chat.wlffinance.org/authorized/${authUser?._id}`,
      name: "Live Chats",
      icon: "menu-icon la-thumbs-up",
      notification: liveChatData,
    },

    // {
    //   auth: authUser?.live_chat,
    //   name: "Live Chat",
    //   icon: "menu-icon la la-ticket",
    //   notification: notificationData?.PendingLiveChats,
    //   subRoutes: [
    //     {
    //       path: "/admin/pending/live/chats/view",
    //       name: "Pending Live Chats",
    //       notification: notificationData?.PendingLiveChats,
    //     },
    //     {
    //       path: "/live/chats",
    //       name: "Live Chats",
    //     },
    //     {
    //       path: "/admin/live/chats/History",
    //       name: "Live Chats History",
    //     },
    //   ],
    // },
    {
      auth: authUser?.report,
      path: "",
      name: "Futures",
      icon: "menu-icon la la-list",
      subRoutes: [
        {
          path: "/admin/futures/news",
          name: "Futures News",
        },
        // {
        //     path: "/admin/users/active",
        //     name: "Notification History",
        // },
      ],
    },
    {
      auth: authUser?.report,
      path: "/settings",
      name: "Report",
      icon: "menu-icon la la-list",
      subRoutes: [
        {
          path: "/admin/users/transaction/logs",
          name: "Transaction Log",
        },
        // {
        //     path: "/admin/users/active",
        //     name: "Notification History",
        // },
      ],
    },

    {
      auth: authUser?.contact_us,
      path: "/admin/contact/us/view",
      name: "Contact Us",
      icon: "menu-icon la-thumbs-up",
    },
    {
      auth: authUser?.manage_section,
      path: "",
      name: "Manage Section",
      icon: "menu-icon la la-puzzle-piece",
      subRoutes: [
        {
          path: "/admin/frontend/frontend-sections/slider",
          name: "Slider Section",
        },
        {
          path: "/admin/frontend/frontend-sections/notices",
          name: "Notices Section",
        },

        {
          path: "/admin/news/view",
          name: "News",
        },
        {
          path: "/admin/social/support",
          name: "Support",
        },
        {
          path: "/admin/gift/view",
          name: "Gift",
        },
      ],
    },

  ];

  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const inputAnimation = {
    hidden: {
      width: 0,
      padding: 0,
      transition: {
        duration: 0.2,
      },
    },
    show: {
      width: "140px",
      padding: "5px 15px",
      transition: {
        duration: 0.2,
      },
    },
  };

  const showAnimation = {
    hidden: {
      width: 0,
      opacity: 0,
      transition: {
        duration: 0.5,
      },
    },
    show: {
      opacity: 1,
      width: "auto",
      transition: {
        duration: 0.5,
      },
    },
  };

  const menuRef = useRef();

  const [mobileMenu, setMobileMenu] = useState();

  useEffect(() => {
    if (menuSHow === true) {
      menuRef.current.style.left = "0px";
    }
    if (mobileMenu === true) {
      menuRef.current.style.left = "-800px";
      setMenuShow(false);
      setMobileMenu(false);
    }
  }, [mobileMenu, menuSHow]);

  return (
    <>
      <div className="default-version">
        <div className="sidebar bg--dark">
          <button
            className="res-sidebar-close-btn"
            onClick={() => setMobileMenu(true)}
          >
            <i className="las la-times"></i>
          </button>
          <div className="sidebar__inner">
            <div className="sidebar__logo">
              <Link to="/admin/dashboard" className="sidebar__main-logo d-flex align-items-center justify-content-center">
                {/* <img
                  src="https://res.cloudinary.com/debfkqhc8/image/upload/v1743102297/npxfpnd7fuu3t7monxwv.jpg"
                  alt=""
                /> */}
                <p className="pt-3 m-0 text-light bold fs-6">
                  WLF Finance
                </p>
              </Link>
            </div>

            <div className="sidebar__menu-wrapper" id="sidebar__menuWrapper">
              <ul className="sidebar__menu">
                {routes.map((route, index) => {
                  if (authUser?._id === undefined) {
                    return (
                      <>
                        <Skeleton
                          count={20}
                          height={10}
                          baseColor="#202020"
                          highlightColor="#444"
                        />
                      </>
                    );
                  } else {
                    if (route.subRoutes) {
                      if (route?.auth === true) {
                        return (
                          <SideBarSubMenu
                            setIsOpen={setIsOpen}
                            route={route}
                            showAnimation={showAnimation}
                            isOpen={isOpen}
                            key={index}
                            setMobileMenu={setMobileMenu}
                          />
                        );
                      }
                    } else if (route.title) {
                      return (
                        <li className="sidebar__menu-header" key={index}>
                          {route.title}
                        </li>
                      );
                    } else {
                      if (route?.auth === true) {
                        return (
                          <SideBarMenu
                            route={route}
                            index={index}
                            key={index}
                            setMobileMenu={setMobileMenu}
                          ></SideBarMenu>
                        );
                      }
                    }
                  }
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="default-version desltop-version">
        <div className="sidebar bg--dark" ref={menuRef}>
          <button
            className="res-sidebar-close-btn"
            onClick={() => setMobileMenu(true)}
          >
            <i className="las la-times"></i>
          </button>
          <div className="sidebar__inner">
            <div className="sidebar__logo">
              <Link href="/admin/dashboard" className="sidebar__main-logo">
                {/* <img
                  src=""
                  alt=""
                /> */}
              </Link>
            </div>
            <div className="sidebar__menu-wrapper" id="sidebar__menuWrapper">
              <ul className="sidebar__menu">
                {routes.map((route, index) => {
                  if (authUser?._id === undefined) {
                    return (
                      <>
                        <Skeleton
                          count={20}
                          height={10}
                          baseColor="#202020"
                          highlightColor="#444"
                        />
                      </>
                    );
                  } else {
                    if (route.subRoutes) {
                      if (route?.auth === true) {
                        return (
                          <SideBarSubMenu
                            setIsOpen={setIsOpen}
                            route={route}
                            showAnimation={showAnimation}
                            isOpen={isOpen}
                            key={index}
                            setMobileMenu={setMobileMenu}
                          />
                        );
                      }
                    } else if (route.title) {
                      return (
                        <li className="sidebar__menu-header" key={index}>
                          {route.title}
                        </li>
                      );
                    } else {
                      if (route?.auth === true) {
                        return (
                          <SideBarMenu
                            route={route}
                            index={index}
                            key={index}
                            setMobileMenu={setMobileMenu}
                          ></SideBarMenu>
                        );
                      }
                    }
                  }
                })}



              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBar;
